// ─── Message Types ───────────────────────────────────────────────────────────
export var WSMessageType;
(function (WSMessageType) {
    /** Server → Browser: execute a tool on the browser side */
    WSMessageType["EXECUTE_TOOL"] = "EXECUTE_TOOL";
    /** Browser → Server: result of a tool execution */
    WSMessageType["TOOL_RESULT"] = "TOOL_RESULT";
    /** Browser → Server: register available tools and skills */
    WSMessageType["REGISTER_CAPABILITIES"] = "REGISTER_CAPABILITIES";
    /** Server → Browser: acknowledge capabilities registration */
    WSMessageType["CAPABILITIES_REGISTERED"] = "CAPABILITIES_REGISTERED";
    /** Browser → Server: register skill(s) from a remote .zip URL */
    WSMessageType["REGISTER_SKILL_ZIP"] = "REGISTER_SKILL_ZIP";
    /** Server → Browser: acknowledge successful zip skill registration */
    WSMessageType["SKILL_ZIP_REGISTERED"] = "SKILL_ZIP_REGISTERED";
    /** Server → Browser: report zip skill registration failure */
    WSMessageType["SKILL_ZIP_ERROR"] = "SKILL_ZIP_ERROR";
    /** Ping / Pong for keep-alive */
    WSMessageType["PING"] = "PING";
    WSMessageType["PONG"] = "PONG";
})(WSMessageType || (WSMessageType = {}));
// ─── Helpers ─────────────────────────────────────────────────────────────────
export function createWSMessage(msg) {
    return JSON.stringify(msg);
}
export function parseWSMessage(data) {
    return JSON.parse(data);
}
//# sourceMappingURL=ws-messages.js.map